import type { PageDialogSettings } from "./settings";

type Opener = (href: string, settings: PageDialogSettings) => boolean;
let opener: Opener | undefined;

/** The page's dialog host registers here; until one has, and outside the website (CMS previews, the guide), a dialog
 *  link navigates like any other link. */
export function registerPageDialogOpener(next: Opener): () => void {
  opener = next;
  return () => {
    if (opener === next) opener = undefined;
  };
}

export function openPageDialog(
  href: string,
  settings: PageDialogSettings,
): boolean {
  return opener?.(href, settings) ?? false;
}
